///<reference path="../../employee/sections/employee.shared.section.ts"/>
module Meevo.Plugins.Teachers {
    'use strict';

    export class SharedSection extends Meevo.Plugins.Employee.SharedSection {
    }
}